export default __webpack_public_path__ + "static/media/bg.46ffdbe5.mp4";